import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const WorkpackageItemCardStyled = styled.div`
  ${({ theme }) => css`
    /* FIXME: remove once ProgressBarDetail can adjust font size (or it scales to size prop) */
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[600]};
  `}
`;

export const OwnerShipTypeBullet = styled(Box)`
 ${({ theme }) =>
    css`
      width: ${theme.spacings[300]};
      height: ${theme.spacings[300]};
      margin: ${theme.spacings[100]} ${theme.spacings[300]} ${theme.spacings[200]} ${theme.spacings[400]};
      border-radius: ${theme.radii[900]};
      display: inline-block;
      background-color: ${theme.colors.grey[600]};
    `}
`;